import axios from "axios";
import { COMPANY_URLS } from "../../../Utils/Company_App_Urls";
import { useContext } from "react";


export const getAllNotification = async (limit = null, page = null) => {
    try {
        const response = await axios.get(`${COMPANY_URLS.getNotification}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            params: {
                limit,
                page,
            },
        });

        return response?.data?.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

let intervalId;

const startFetchingNotifications = () => {
    intervalId = setInterval(async () => {
        await getAllNotification();
    }, 10000);  // Fetch notifications every 10 seconds instead of 1 second
};

const stopFetchingNotifications = () => {
    clearInterval(intervalId);
};

// startFetchingNotifications();


export const markAsReadNotification = async (id = '') => {
    axios.patch(`${COMPANY_URLS.readNotification}/${id}`, { "status": "read" }, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
    })
        .then((res) => { })
        .catch((err) => console.error(err))
};

export const markAllAsRead = (setNotificationLoader) => {

    setNotificationLoader(true)
    axios.patch(`${COMPANY_URLS?.readAllNotifications}`, { "status": "read" }, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        }
    })
        .then((res) => {
            getAllNotification()
            return res
        })
        .catch((err) => console.error(err))
        .finally(() => setNotificationLoader(false))
}

export const markReadAndRefreshNotifications = async (id, limit = 5, page = 1) => {
    try {
        await markAsReadNotification(id);

        const notifications = await getAllNotification(limit, page);
        
        return notifications;
    } catch (error) {
        throw error;
    }
};
